import {Component, OnDestroy, OnInit, output} from '@angular/core';
import {MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon'; 
import { UserinfoFaqContentComponent } from './userinfo-faq-content/userinfo-faq-content.component';
import { environment } from '../../../../environments/environment';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../state-management/model/enums/screen-size.enums';
import { ScreensizeStateService } from '../../../state-management/services/screensize-state.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-userinfo-faq',
    standalone: true,
    imports: [
      MatButtonModule, 
      MatDialogModule, 
      MatIconModule, 
    ],
    templateUrl: './userinfo-faq.component.html',
    styleUrl: './userinfo-faq.component.scss'
})
export class UserinfoFaqComponent implements OnInit, OnDestroy {
  private dialogSubscription: Subscription = new Subscription();

  public isSmallScreen$ = this.screenSize.isScreenSize(CoordinatesSystem.ScreenWidth, ScreenWidthBreakpoints.XSmall);
  constructor(public dialog: MatDialog, private screenSize: ScreensizeStateService) {}
  readonly buttonClicked = output<void>();

  ngOnInit() {
  }

  ngOnDestroy() {
    if(this.dialogSubscription) this.dialogSubscription.unsubscribe();
  }
  
  stopAnnimation() {
    this.buttonClicked.emit();
  }

  openDialog() {
    const dialogRef = this.dialog.open(UserinfoFaqContentComponent, { panelClass: 'admin-theme' });

    this.dialogSubscription = dialogRef.afterClosed().subscribe(result => {
    });
  }

  handleClick() {
    this.stopAnnimation();
    this.openDialog();
  }
}
